// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__u1YEA","container":"Layout_container__HDv5Y"};